//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import React, { useEffect, useState } from "react";
import axios from "axios";
let IPDATA_API_KEY = "b66ad5c2529766c339602156c1d200369fd5d8256c406d7ed4d3697d";

const endpoints = {
  vicinity: "https://frontend-service-rouge.vercel.app/regions/", //Change to region
};

export const getIPData = (client_ip) => {
  let input = client_ip || "";
  return axios.get(`https://api.ipdata.co/${input}?api-key=${IPDATA_API_KEY}`);
};
export function fetchRegions(country = "nigeria") {
  return axios.get(endpoints.vicinity + country);
}

export function fetchGeneratedIpLocation(client_ip?: any) {
  return getIPData(client_ip)
    .then((res) => {
      let { region: state, country_name: country, country_code } = res.data;
      let newValue = { country, state, country_code };
      newValue.state = (newValue.state || "").replace(" State", "");
      return newValue;
    })
    .catch((e) => {
      console.log(e);
      let newValue: any = {
        country: "Nigeria",
        state: "Lagos",
        display_country: true,
        country_code: "NG",
      };
      return newValue;
    });
}
const defaultValue = {
  country: "",
  state: "",
  region: "",
};
export const useGetRegionAndIpLocation = ({
  value = defaultValue,
  fetchedRegions = [],
  fetchedIpLocations = {},
  fetchedCountries = [],
}: any) => {
  let _defaultValue = fetchedIpLocations;
  ["state", "country", "region"].forEach((field) => {
    if (!_defaultValue[field]) {
      if (value[field]) {
        _defaultValue[field] = value[field];
      }
    }
  });

  const [regions, setRegions] = useState(fetchedRegions);
  const [ip_location, setIpLocation] = useState(_defaultValue);
  const [showCountry, setShowCountry] = useState(false);
  const autoFillFromIP = () => {
    if (
      Object.keys(fetchedIpLocations).length == 0 &&
      fetchedIpLocations.state &&
      fetchedIpLocations.region
    ) {
      fetchGeneratedIpLocation().then(({ display_country, ...newValue }) => {
        if (display_country) {
          setShowCountry(true);
        }
        ["region", "state", "country"].forEach((field) => {
          if (!newValue[field]) {
            if (ip_location[field]) {
              newValue[field] = ip_location[field];
            }
          }
        });
        setIpLocation({ ...value, ...newValue });
      });
    }
  };

  useEffect(() => {
    // We're fetching our custom Region/Vicinity data from Sheety API
    if (fetchedRegions.length == 0) {
      fetchRegions()
        .then(({ data }) => setRegions(data.data))
        .catch((error) => {});
    }

    // Autofill the form if country is empty
    !value.country && autoFillFromIP();
  }, []);
  return [regions, ip_location, fetchedCountries, showCountry];
};

export const useLocation = ({
  valueProp = defaultValue,
  regions = [],
  countries = [],
}) => {
  const [value, setValue] = useState(valueProp);
  // const [regions, setRegions] = useState([]);
  // const [showCountry, setShowCountry] = useState(false);

  useEffect(() => {
    setValue(valueProp);
  }, [valueProp]);

  let getStates = (country) => {
    if (country) {
      let stateOptions = countries.find((item) => item.name === country);
      if (stateOptions) {
        stateOptions = stateOptions.states.map((item) => item.name);
      }
      return stateOptions || [];
    }
    return [];
  };

  let getRegions = (state) => {
    if (state) {
      let regionOptions = regions
        .filter((item) => item.state === state)
        .map((item) => item.vicinity);
      return regionOptions;
    }
    return [];
  };

  let countryOptions = countries.map((item) => item.name);
  let stateOptions = getStates(value.country);
  let regionOptions = getRegions(value.state);

  const formatOptions = (options) => {
    return options.map((item) => ({ label: item, value: item }));
  };

  const handleChange = (key, selectedOption) => {
    let newValue = value;

    if (key === "state") {
      newValue = {
        country: value.country,
        state: selectedOption.value,
        region: "",
      };
    }

    if (key === "region") {
      if (selectedOption) {
        newValue = { ...value, region: selectedOption.value };
      } else {
        newValue = { ...value, region: "" };
      }
    }

    if (key === "country") {
      let fetchedStates = getStates(selectedOption.value);
      newValue = {
        country: selectedOption.value,
        state: fetchedStates[0],
        region: "",
      };
    }

    setValue(newValue);
  };
  return {
    value,
    handleChange,
    countryOptions,
    stateOptions,
    regionOptions,
    formatOptions,
  };
};
